"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[3511],{

/***/ 86559
(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loki_icon.abc01135.svg";

/***/ },

/***/ 27323
(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mimir_logo.ac01ecbc.svg";

/***/ },

/***/ 33611
(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/prometheus_logo.3e9d4662.svg";

/***/ }

}]);